import Route from 'cio/routes/base';
import AttributesIndexController from 'cio/pods/person/attributes/index/controller';
import { inject as service } from '@ember/service';
import DS from 'ember-data';

export default class IndexRoute extends Route {
  @service store!: DS.Store;

  model() {
    let { object_id } = this.paramsFor('object') as Record<string, string>;
    return this.store.findRecord('object', object_id);
  }

  deactivate() {
    super.deactivate();

    (this.controller as AttributesIndexController).set('searchTerm', '');
  }
}
